import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActionsService } from '../../actions.service';
import { TModulesService } from '../../../t-modules/t-modules.service';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-actions-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})

export class CreateComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  formData: FormGroup;
  listModules: any[] = [];

  constructor(
    private moduleService: TModulesService,
    private actionsService: ActionsService,
    private fb: FormBuilder,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.loadAllModules();
    this.subscribeObservables();
  }

  subscribeObservables() {
    this.subscriptions.push(
      this.actionsService.actionId$.subscribe((actionId: number) => {
        if (actionId) {
          this.loadActionData(actionId);
        }
      })
    );
  }

  loadActionData(actionId: number) {
    if (actionId) {
      this.subscriptions.push(
        this.actionsService.getActionByID(actionId).subscribe(
          (resp: any) => {
            this.formData.patchValue({
              actionid: resp.actionid,
              description: resp.description,
              moduleid: resp.moduleid,
            });
          },
          (error) => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error!',
              text: error.message,
              type: 'error',
            });
          }
        )
      );
    }
  }

  createForm() {
    this.formData = this.fb.group({
      actionid: [''],
      description: ['', Validators.required],
      moduleid: ['', Validators.required],
    });
  }

  loadAllModules() {
    this.subscriptions.push(
      this.moduleService.getModules().subscribe(
        (resp: any) => {
          if (resp) {
            this.listModules = resp;
          }
        },
        (error) => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error!',
            text: error.message,
            type: 'error',
          });
        }
      )
    );
  }

  save() {
    const formData = Object.assign({}, this.formData.value);
    if (formData.actionid) {
      this.subscriptions.push(
        this.actionsService.putData(formData).subscribe(
          (resp) => {
            if (resp) {
              this.sweetAlertHelper
                .createCustomAlert({
                  title: 'Success',
                  text: resp.message,
                  type: 'success',
                })
                .then(() => {
                  this.actionsService.save.next(true);
                });
            }
          },
          (error) => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error!',
              text: error.message,
              type: 'error',
            });
          }
        )
      );
    } else {
      this.subscriptions.push(
        this.actionsService.postData(formData).subscribe(
          (resp) => {
            this.sweetAlertHelper
              .createCustomAlert({
                title: 'Success',
                text: resp.message,
                type: 'success',
              })
              .then(() => {
                this.actionsService.save.next(true);
              });
          },
          (error) => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error!',
              text: error.message,
              type: 'error',
            });
          }
        )
      );
    }
  }

  cancel() {
    this.actionsService.save.next(false);
  }

  get titleModule(): string {
    return this.formData.get('actionid').value
      ? 'Edit Action'
      : 'Add New Action';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/actions/components/create/create.component.ts